import { FC } from 'react'
import { OutfitProps } from './types'
import { StandardProductCard } from '@/features/product/components/StandardProductCard'
import { createLiquidExtendedProductHit } from '@/features/product/utils/createExtendedProductHit'
import classNames from 'classnames'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import useEmblaCarousel from 'embla-carousel-react'
import { Text, Image as ImageComponent, Carousel } from '@lounge-fe/ui-kit'
import { usePreventEdgeScrolling } from '@/hooks/usePreventEdgeScrolling'
import { ErrorBoundary } from '@sentry/react'

const Outfit: FC<OutfitProps> = ({ outfit }) => {
  const [emblaRef, embla] = useEmblaCarousel(
    {
      align: 'start',
      containScroll: 'trimSnaps',
      skipSnaps: false,
      active: true,
      loop: false,
      dragFree: false,
    },
    [WheelGesturesPlugin()],
  )

  embla?.on('scroll', usePreventEdgeScrolling(embla))

  return (
    <ErrorBoundary>
      <div
        data-attr="outfit-builder"
        className="pb-14 mt-14 max-w-[calc(100%_-_48px)] md:max-w-[75vw] m-auto"
      >
        <div className="text-center w-full max-w-[684px] m-auto pb-6 md:pb-14">
          {outfit.title && (
            <Text variant="title-five" className="mb-4">
              {outfit?.title}
            </Text>
          )}
          {outfit.description && (
            <Text variant="body-sm" className="text-[#888888]">
              {outfit?.description}
            </Text>
          )}
        </div>
        <div className="flex items-center flex-row gap-10">
          <div className="basis-1/2 hidden md:flex">
            <div className="aspect-[4/5] w-full h-full bg-[#E7E7E7]">
              {outfit.image && (
                <ImageComponent
                  data={{
                    src: outfit.image?.src,
                    width: 628,
                    height: 784,
                  }}
                  alt={outfit.image?.alt}
                  className="object-cover w-full h-full"
                />
              )}
            </div>
          </div>
          <div className="md:basis-1/2 overflow-hidden">
            <Carousel emblaRef={emblaRef} embla={embla}>
              <Carousel.Viewport showOverflow>
                <Carousel.Container
                  className={classNames('auto-cols-[calc(80%-12px)] gap-x-2')}
                >
                  {outfit.products.map((product, idx) => {
                    return (
                      <Carousel.Slide index={idx} key={product.id}>
                        <StandardProductCard
                          key={product.id}
                          aspectRatio="1/1"
                          product={createLiquidExtendedProductHit(product)}
                          useQuickAdd
                        />
                      </Carousel.Slide>
                    )
                  })}
                </Carousel.Container>
              </Carousel.Viewport>
            </Carousel>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export { Outfit }
